// extracted by mini-css-extract-plugin
module.exports = {"mainContainer":"App_mainContainer__1t-cS","mainLogo":"App_mainLogo__VshIz"};